import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { MenuItem, Popover } from '@mui/material';
import { useTranslation } from 'react-i18next';

const OrgManageUserAction = ({ popoverElement, handleCloseMenu, handleOpenConfirm }) => {
  const { t: translate } = useTranslation();
  return (
    <Popover
      open={Boolean(popoverElement)}
      anchorEl={popoverElement}
      onClose={handleCloseMenu}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: { p: 1, width: 200, '& .MuiMenuItem-root': { px: 1, typography: 'body2', borderRadius: 0.75 } },
      }}
    >
      <MenuItem sx={{ color: 'warning.main' }} onClick={() => handleOpenConfirm('remove')}>
        <RemoveCircleIcon sx={{ mr: 1 }} /> {translate('manage_brand.manage_users.remove_from_organization')}
      </MenuItem>
    </Popover>
  );
};
export default OrgManageUserAction;
